import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class PayerBankAccountsSynchronization {
  @Expose()
  @IsOptional()
  @IsString()
  lastSync!: string | null;

  @Expose()
  @IsBoolean()
  canSync!: boolean;

  @Type(() => PayerBankAccount)
  @ValidateNested()
  @Expose()
  bankAccounts!: Array<PayerBankAccount>;
}

export class PayerBankAccount {
  @Expose()
  @IsNumber()
  id!: number;

  @Expose()
  @IsString()
  accountNumber!: string;

  @Expose()
  @IsBoolean()
  isArchived!: boolean;

  @Expose()
  @IsNumber()
  recordStampId!: number;
}

export class EditCPBankAccount {
  @Expose()
  @IsString()
  accountNumber!: string;

  @Expose()
  @IsBoolean()
  isArchived!: boolean;

  constructor() {
    this.accountNumber = "";
    this.isArchived = false;
  }
}
